import * as React from 'react';
import { SVGProps } from 'react';

const IconOilBarrelSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 2a1 1 0 1 1 2 0h2a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2h12Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 12a1 1 0 1 0 0 2v6H4a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2h-1v-6a1 1 0 1 0 0-2V5H5v7Zm4 1.978c0-.508.182-1.273.652-2.278.455-.975 1.09-1.987 1.774-2.933.192-.266.385-.523.574-.767.19.244.382.5.574.767.683.946 1.319 1.958 1.774 2.933.47 1.005.652 1.77.652 2.278C15 15.74 13.702 17 12 17s-3-1.26-3-3.022Z"
    />
  </svg>
);
export default IconOilBarrelSizeM;
